import { useEffect, useState } from "react";
import { api, todayISO } from "@/api";
import { Users, Filter } from "lucide-react";
import ReportCard from "@/components/ReportCard";

export default function TeamFeedPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateFilter, setDateFilter] = useState("");

  const load = async (date) => {
    setLoading(true);
    try {
      const params = date ? { date, limit: 100 } : { limit: 50 };
      const { data } = await api.get("/reports/team", { params });
      setItems(data.items || []);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(dateFilter); /* eslint-disable-next-line */ }, [dateFilter]);

  return (
    <>
      <div className="page-heading compact-heading">
        <div>
          <p className="eyebrow">Ekip</p>
          <h1>Ekip raporları</h1>
          <p className="subheading">Tüm çalışanların son raporları — yorum ve beğeni ekleyebilirsiniz.</p>
        </div>
        <div className="heading-actions">
          <label style={{ display: "flex", alignItems: "center", gap: 8, color: "#8390a5", fontSize: 12 }}>
            <Filter size={14}/> Tarih:
            <input type="date" value={dateFilter} max={todayISO()} onChange={(e)=>setDateFilter(e.target.value)}
              style={{ padding: "6px 10px", background: "#0c1421", border: "1px solid #304058", borderRadius: 6, color: "#e4ecf6", fontSize: 12 }}
              data-testid="team-date-filter"/>
            {dateFilter && <button className="text-button" onClick={()=>setDateFilter("")} data-testid="clear-date-filter">Temizle</button>}
          </label>
        </div>
      </div>

      {loading ? (
        <div className="loading-block">Yükleniyor…</div>
      ) : items.length === 0 ? (
        <div className="empty-state">
          <Users size={28}/>
          <h3>{dateFilter ? "Bu tarihte rapor yok" : "Henüz ekip raporu yok"}</h3>
          <p>İlk raporlar yazılınca burada görünecek.</p>
        </div>
      ) : (
        <div className="reports-grid" data-testid="team-feed">
          {items.map((r) => <ReportCard key={r.id} report={r} onChanged={() => load(dateFilter)} />)}
        </div>
      )}
    </>
  );
}
